import {
  read_request_time_warning,
  with_request_time_ack
} from '../request_time_warning/request_time_warning_rules';
import {
  read_pay_time_warning,
  with_pay_time_ack
} from '../pay_time_warning/pay_time_warning_rules';

// A-52 on a Care record save: goserver checks the request time against the booking/class start first
// (409 REQUEST_TIME_WARNING, ack request_time_ack {warning, note?}), then against an earlier change on the
// class (409 PAY_TIME_WARNING BEFORE_EARLIER_CHANGE, ack pay_time_ack {warnings, note}). A resend keeps both.

// The warning step to show for a failed save, or null for any other error.
export const read_care_save_warning = (e) =>
  read_request_time_warning(e) || read_pay_time_warning(e);

// A pay-time warning/ack carries a warnings[] list; a request-time one a single warning code.
export const is_pay_time_warning = (w) => !!w && Array.isArray(w.warnings);

// The payload (or an acks fragment) with this ack added under its own key; earlier acks are kept.
export const with_care_ack = (payload, ack) => {
  if (!ack) return payload;
  return is_pay_time_warning(ack)
    ? with_pay_time_ack(payload, ack)
    : with_request_time_ack(payload, ack);
};

// The acks a payload carries, for a follow-up PUT of the same record (ALREADY_RECORDED fallback).
export const care_acks_of = (payload) => ({
  ...(payload && payload.request_time_ack ? { request_time_ack: payload.request_time_ack } : {}),
  ...(payload && payload.pay_time_ack ? { pay_time_ack: payload.pay_time_ack } : {})
});
